import { render } from "./MerchView.vue?vue&type=template&id=4fd5a6e3"
import script from "./MerchView.vue?vue&type=script&lang=js"
export * from "./MerchView.vue?vue&type=script&lang=js"

import "./MerchView.vue?vue&type=style&index=0&id=4fd5a6e3&lang=scss"

import exportComponent from "/Users/davidebertuzzi/WebstormProjects/procremonafrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__